var transform = {
  serializeIn: function serializeIn(settings) {
    var tooltipSettings = settings.tooltipSettings,
        layout = settings.layout;
    return {
      layout: layout,
      xAxisTitle: settings.xAxisTitle,
      yAxisTitle: settings.yAxisTitle,
      formatValue: tooltipSettings && typeof tooltipSettings.formatValue === 'string' ? tooltipSettings.formatValue : null
    };
  },
  serializeOut: function serializeOut(_ref) {
    var formatValue = _ref.formatValue,
        xAxisTitle = _ref.xAxisTitle,
        yAxisTitle = _ref.yAxisTitle,
        layout = _ref.layout;
    return {
      xAxisTitle: xAxisTitle,
      yAxisTitle: yAxisTitle,
      layout: layout,
      tooltipSettings: {
        formatValue: formatValue
      }
    };
  }
};
export default transform;